<template>
  <div>
    <el-row :gutter="30" class="intro-container">
      <el-col :span="24">
        <span style="text-transform:capitalize;">Hello {{firstName}}!</span>
        <p>{{welcomeMessage}}</p>
      </el-col>
    </el-row>


    <h3 class="section-title">Photo Submission & Updates</h3>
    <progress-pic></progress-pic>
    <progress-after-pic />
    <h3 class="section-title">Featured Posts</h3>
    <article-preview :featured="true"/>
    <h3 class="section-title">News & Blog Content</h3>
    <article-preview/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ArticlePreview from '../content/article-preview';
import ProgressPic from '../progress/prestage-pic-uploader.vue';
import ProgressAfterPic from '../progress/after-pic-uploader.vue';

export default {
  name: 'home',
  computed: mapGetters({
    welcomeMessage: 'welcomeMessage'
  }),
  mounted: function(){
    //console.log(this.$route.query.after)
    //console.log(moment().format('DDMM'))

    //console.log(moment('07-29-2018').unix());

    //console.log(moment('07-28-2018').unix());
    if(this.$route.query.after || moment('07-29-2018').unix() < moment().unix()){
      this.showPhoto = true;
    }
    var user = Parse.User.current();
    console.log(user.get('isAdmin'));
    if(user) this.firstName = user.get('firstName');
    if(!user) {
      this.$router.push('/login');
       return
    }
    if(!user.get('programs')){
       this.$router.push('/dashboard/my-details');
       return
    }
  },
  components:{ArticlePreview, ProgressPic, ProgressAfterPic},
  data () {
    return {
      showPhoto: false,
      firstName:null,
      checkinData:{
        weight:null
      },
      weightLogged: false,
      currentDate: new Date(),
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onSubmitWeight:function(){
      this.weightLogged = true;
    },
    openSuccess: function(){
        this.$alert('Good job, looks like this is your 14th checking in a row!', 'Awesome!', {
          confirmButtonText: 'Done',
          type:'success',
          callback: action => {
            this.$message({
              type: 'success',
              message: 'Your check-in has been saved!'
            });
          }
        });
      },
      openFail: function(){
        this.$alert('It happens to all of us. Get tomorrow in. ', 'Darn!', {
          confirmButtonText: 'Done',
          callback: action => {
            this.$message({
              type: 'success',
              message: 'Your check-in has been saved!'
            });
          }
        });
      }
  }
}
</script>

<style>
  .el-row {
    margin-bottom: 20px;
    /* &:last-child {
      margin-bottom: 0;
    } */
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .intro-container span {
    font-weight: bold;
    font-size: 18px;
    color:#666;
    width: 100%;
    text-align: left;
    display: block;
  }
  .intro-container p {
    font-size: 18px;
    color:#555;
    width: 100%;
    text-align: left;
    display: block;
    margin-top:10px;
  }

  .checking-box {
    background-color: #FFF;
    padding: 35px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
  .checking-box.activity{
    border-bottom: 10px solid #2CA8DF;
  }
  .checking-box.nutrition{
    border-bottom: 10px solid #D70073;
  }
  .checking-box h4{
    color: #666;
    text-transform: uppercase;
    margin:0px 30px 5px;
    font-size: 22px;
  }

    .checking-box p {
      color: #999;
      margin-top: 0;
      font-size: 14px;
    }
    .checking-box span i{
      font-size: 30px;
      color: #CCC;
      margin:0 10px;
    }
     .checking-box span i:hover{
      color: #666;
     }

    .weight-container form{
      background-color: #FFF;
      padding: 15px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .weight-container .progress-container{
      height: 18px;
      padding: 15px;
    }
    .weight-container label {
      color: #999;
    }
    .weight-container input { width: 400px; }
    .weight-container .el-form-item{
      margin: 0;
    }


    .goal-bar{width:80%; display: inline-block; float: left;}
    .goal-title{width:20%; display: inline-block;float: left; color: #999; font-size: 14px;}
</style>
